import { render, staticRenderFns } from "./Deceased.vue?vue&type=template&id=164e8b06&"
import script from "./Deceased.vue?vue&type=script&lang=js&"
export * from "./Deceased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports